import { AssignmentDTO } from "../../../../app/shared/models/Assignment";
import { ActionItemAttachmentDetails } from "./action-item-attachment-details";

export class ActionItemDetails {
    actionItem!: string | null;
    status!: number | null;
    statusName!: string | null;
    requestedNextStatus!: string | null;
    completeDate!: Date | null;
    dueDate!: Date | null;
    assignedUser!: string | null;
    verifier!: string | null;
    verifierNotes!: string | null;
    description!: string | null;
    actionType!: number | null;
    actionTypeName!: string | null;
    riskAssesmentRequired!: boolean | null;
    actionTaken!: string | null;
    changeControlNumber!: string;
    actionItemNumber!: string | null;
    attachments!: any | null;
    actionItemSpeedDial! : Record<string, boolean> | null;
    verificationRequired!: boolean | null;
    assignedUserInfo!: AssignmentDTO | null;
    verifierInfo!: AssignmentDTO | null;
}
